import { createContext, useState, useCallback } from 'react';
import { IAdditionalVariantsQuotes } from '../model/IFinanceQuote';

export interface IMultipleQuotesContext {
  financeQuotes: IAdditionalVariantsQuotes | null;
  setFinanceQuotes: (quotes: IAdditionalVariantsQuotes) => void;
}

export const MultipleQuotesContext = createContext<IMultipleQuotesContext>({
  financeQuotes: null,
  setFinanceQuotes: () => null,
});

export const getMultipleQuotesContextValue: () => IMultipleQuotesContext = () => {
  const [financeQuotes, setFQ] = useState<IAdditionalVariantsQuotes | null>(null);

  const setFinanceQuotes = useCallback((quote: IAdditionalVariantsQuotes) => {
    setFQ(quote);
  }, []);

  return { financeQuotes, setFinanceQuotes };
};
